const DeleteIcon = ({ size = 13 }: { size?: number }) => {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 13 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{
                width: size,
                height: size,
                maxWidth: size,
                maxHeight: size,
            }}
        >
            <path
                fill-rule="evenodd"
                clipRule="evenodd"
                d="M2.69113 2.11873V10.1812C2.69113 10.7406 3.1505 11.2 3.70987 11.2H9.2901C9.84947 11.2 10.3088 10.7406 10.3088 10.1812V2.11873H2.69113ZM4.69685 4.03485C4.69685 3.5083 5.49685 3.5083 5.49685 4.03485V8.04523C5.49685 8.57178 4.69685 8.57178 4.69685 8.04523V4.03485ZM7.5031 4.03485C7.5031 3.5083 8.30309 3.5083 8.30309 4.03485V8.04523C8.30309 8.57178 7.5031 8.57178 7.5031 8.04523V4.03485ZM7.59477 1.31874V0.799995H5.40518V1.31874H7.59477ZM4.60519 1.31874V0.399997C4.60519 0.179172 4.78436 0 5.00518 0H7.99476C8.21559 0 8.39476 0.179172 8.39476 0.399997V1.31874H11.8035C12.3301 1.31874 12.3301 2.11873 11.8035 2.11873H11.1093V10.1812C11.1088 11.1822 10.2911 12 9.28995 12H3.70972C2.70869 12 1.89094 11.1823 1.89094 10.1812V2.11873H1.19668C0.670119 2.11873 0.670119 1.31874 1.19668 1.31874H4.60492H4.60519Z"
                fill="#E3725D"
            />
        </svg>
    );
};

export default DeleteIcon;
